<div class="row1" id="teamDiv">
  <div class="col-md-12 float-left">
    <mat-card appearance="outlined" class="card-widget nopadLR marB16 mat-card">
      <div class="row">
        <div class="col-12 marT8">
          <h4 class="marB8 margin-left-20" name="teamheading">
            <strong class="teamhed">Team</strong>
          </h4>
          <span class="customFloat" *ngIf="!showInput" (click)="showInputClick()">
            <img src="assets/images/icons/default_icons/icon_search.png" alt="search-img" />
          </span>
          <span class="customFloat" *ngIf="showInput">
            <mat-form-field class="customMatFormField">
              <input
                matInput
                type="text"
                autocomplete="off"
                (keypress)="keyPressedAlphabets($event)"
                [formControl]="teamSearch"
                [errorStateMatcher]="matcher"
              />
              <button mat-button (click)="clearInput()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="teamSearch.hasError('pattern')"> Please enter valid name. </mat-error>
            </mat-form-field>
          </span>
        </div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="10" class="scroll-viewport">
        <ul class="listItemSingle">
          <li *ngFor="let team of filteredTeamData; let index = index">
            <span
              matRipple
              [matRippleColor]="ripcolor"
              class="clearfix mat-ripple"
              [ngClass]="team.checked ? 'customClass' : ''"
            >
              <span class="listLeft">
                <div class="icon-container inline" *ngIf="team.flag != 0; else elsepart">
                  <span
                    class="data-letters float-left marR16"
                    id="initials-{{ index }}"
                    *ngIf="!team.checked"
                    (click)="changeIcon(team)"
                    style="cursor: pointer"
                    >{{ team.employeeName | initials }}</span
                  >
                  <span
                    class="custom-img float-left marR16"
                    id="process-icon"
                    *ngIf="team.checked"
                    (click)="changeIcon(team)"
                    ><img alt="icon-tick-dark" src="assets/images/icons/purple_icons/icon-process-complete-big.png"
                  /></span>
                  <div *ngIf="!team.checked" class="status-circle"></div>
                  <span (click)="toggle(team)" class="marginicon40 displayBlock inline">
                    <div style="cursor: pointer">
                      <h5 class="h5Header GreyDarkest inline" id="teammembername{{ index }}">
                        {{ team.employeeName }}
                      </h5>
                    </div>

                    <span class="mainBodyTxt4 GreyLight d-block marT4" id="teamrolename{{ index }}">{{
                      team.roleName
                    }}</span>
                  </span>
                </div>
                <ng-template #elsepart>
                  <div class="icon-container inline">
                    <span class="data-letters float-left marR16" id="{{ team.employeeName | initials }}">{{
                      team.employeeName | initials
                    }}</span>
                    <div class="status-circle-leave"></div>

                    <span class="marginicon40 inline">
                      <h5 class="h5Header GreyDarkest inline" id="teammembername{{ index }}">
                        {{ team.employeeName }}
                      </h5>
                      <span class="mainBodyTxt4 GreyLight d-block marT4" id="teamrolename{{ index }}">{{
                        team.roleName
                      }}</span>
                    </span>
                  </div>
                </ng-template>
              </span>

              <span class="vertical-RightCenter float-right" *ngIf="team.flag != 0" id="teamdetail">
                <div class="row">
                  <span class="donut-chart float-left marR16" *ngIf="team.displayChart">
                    <app-donut-chart [chartData]="team.chart" id="teamchart{{ index }}"> </app-donut-chart>
                  </span>
                  <span class="marLR16 marT16">
                    <span class="float-left" [matMenuTriggerFor]="menu" name="buttonmenu" style="cursor: pointer">
                      <img
                        src="assets/images/icons/default_icons/icon-v-menu.png"
                        alt="icon-v-menu"
                        style="width: 8px; margin-top: -18px"
                      />
                    </span>
                  </span>
                  <mat-menu #menu="matMenu" id="menuleaveupdatedelete">
                    <button
                      mat-menu-item
                      (click)="open(content, index)"
                      name="leaveupdatebutton"
                      class="button-leave-menu"
                    >
                      Leave Update
                    </button>
                    <button
                      mat-menu-item
                      (click)="deleteTeamMember(team.employeeNumber)"
                      name="leavedeletebutton"
                      class="button-leave-menu"
                    >
                      Delete
                    </button>
                  </mat-menu>
                </div>
              </span>

              <span class="for-leave" id="Leave" *ngIf="team.flag === 0" name="onleave">Leave</span>
            </span>
            <hr />
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>

      <ng-container *ngIf="edited">
        <div class="row listItemSingle marT16">
          <div class="col-lg-2 col-md-2 col-sm-2">
            <img alt="image_avatar" src="assets/images/card-avatar.png" class="float-left" />
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7">
            <div class="marginicon40">
              <div>
                <input
                  matInput
                  placeholder="Enter Name"
                  [(ngModel)]="inputText"
                  (keyup)="validateRegex(employeeName.value)"
                  #employeeName
                  [formControl]="teamControl"
                  [matAutocomplete]="auto"
                  name="teaminputbox"
                />

                <mat-autocomplete #auto="matAutocomplete">
                  <ng-container *ngFor="let team of filteredOptions | async; let index = index">
                    <mat-option
                      *ngIf="team.flag != 1 || team.active == false"
                      (onSelectionChange)="onMemberadd(team)"
                      [value]="team.employeeName"
                      id="enterteammembername{{ index }}"
                    >
                      {{ team.employeeName }}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </div>
              <div>
                <span class="mainBodyTxt4 GreyLight blockInfo marT4" name="enterdesignation">Designation</span>
              </div>
              <div *ngIf="errorMessage" class="nopad nomar custom-style">
                <span class="mat-error DSA_infoTxt">{{ errorMessage }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3" style="position: relative">
            <span class="vertical-RightCenter">
              <button
                href="javascript:void(0);"
                class="float-left addbutton"
                (click)="addMember()"
                [disabled]="inputText.length == 0"
                name="addteamicon"
              >
                <img alt="icon-tick-dark" src="assets/images/icons/purple_icons/icon-tick-dark.png" />
              </button>
              <button
                name="closingIcon"
                href="javascript:void(0);"
                class="float-left padL16 addbutton"
                (click)="closeUpdate()"
              >
                <img alt="icon-close" src="assets/images/icons/purple_icons/icon-close.png" />
              </button>
            </span>
          </div>
        </div>
      </ng-container>
      <button
        mat-stroked-button
        class="margin-button"
        (click)="add()"
        *ngIf="leaveCount != 0 || activeState != 0"
        [ngStyle]="{ outline: '0' }"
        name="addmemberbutton"
      >
        + Add New member
      </button>
      <button
        mat-stroked-button
        class="margin-button"
        *ngIf="(role === 'DCAD' || role === 'VLAD') && companyHiringType != '1' && companyHiringType != '4'"
        [disabled]="disableallocate"
        (click)="Allocate()"
        [ngStyle]="{ outline: '0' }"
        name="autoallocatebutton"
      >
        + Auto Allocate
      </button>
    </mat-card>

    <ng-template #content let-modal>
      <div style="margin-right: 10px">
        <button
          button
          class="clsbutt float-right"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
          name="closemodal"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-header">
        <h4 class="DSA_h4Header" id="modal-basic-title" name="leavemodalheader">Leave Update</h4>
      </div>

      <div class="modal-body">
        <form [formGroup]="updateForm" (ngSubmit)="onSubmit(updateForm)">
          <div class="row">
            <div class="col-md-12 col-sm-6 col-12 col-lg-4">
              <mat-form-field class="custom-form-field">
                <mat-label>Associate</mat-label>
                <mat-select [(ngModel)]="selectedMember" formControlName="employeename" name="assocaite">
                  <mat-option
                    *ngFor="let team of filteredTeamData; let index = index"
                    (onSelectionChange)="onMemberSelect(team)"
                    id="teammemberdropdown{{ index }}"
                    [(value)]="team.employeeNumber"
                    >{{ team.employeeName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-6 col-12 col-lg-4">
              <mat-form-field class="custom-form-field" name="FormDateField">
                <mat-label name="FromDate">From</mat-label>
                <input
                  formControlName="fromdate"
                  [(value)]="selectedDate"
                  matInput
                  [min]="todaydate"
                  [matDatepicker]="picker"
                  id="{{ updateForm.value.fromdate }}"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-sm-6 col-12 col-lg-4">
              <mat-form-field class="custom-form-field" name="ToDateField">
                <mat-label name="ToDate">To</mat-label>
                <input
                  formControlName="todate"
                  [(value)]="selectedToDate"
                  matInput
                  [min]="updateForm.get('fromdate').value"
                  [matDatepicker]="picker1"
                  id="{{ updateForm.value.todate }}"
                />
                <mat-datepicker-toggle matSuffix [for]="picker1"> </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-sm-6 col-12 col-lg-4">
              <mat-form-field class="custom-form-field" name="TimeField">
                <mat-label name="Time">Time</mat-label>
                <mat-select formControlName="time" name="SelectedTime">
                  <mat-option *ngFor="let tm of times; let index = index" [value]="tm.viewValue" id="time{{ index }}">
                    {{ tm.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-6 col-12 col-lg-4">
              <mat-form-field class="custom-form-field">
                <mat-label>Description(optional)</mat-label>
                <input type="text" formControlName="description" matInput name="leavedescription" />
              </mat-form-field>
            </div>
            <div
              *ngIf="updateForm.get('description').hasError('pattern')"
              class="col-md-12 col-sm-12 col-12 col-lg-12 nopad nomar custom-font"
            >
              <span class="mat-error DSA_infoTxt">Special Characters and Numbers are not allowed</span>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          mat-flat-button
          class="primary-btn"
          (click)="updateLeave(modal.close())"
          [disabled]="!updateForm.valid"
          name="updateleavebutton"
        >
          Update Leave
        </button>
      </div>
    </ng-template>

    <div class="col-lg-3 col-md-3 col-sm-3"></div>
  </div>
</div>
<div id="overlay">
  <mat-card appearance="outlined" class="customCard">
    <div>
      <button
        mat-flat-button
        type="button"
        class="close float-right"
        style="margin-right: 10px"
        (click)="close()"
        [ngStyle]="{ outline: '0' }"
        name="close-btn"
      >
        <span>x</span>
      </button>
    </div>
    <div class="modal-header" style="margin-top: 14px">
      <div class="header_row">
        <span>
          <h4 class="h2Header float-left" id="modal-basic-title">Assign Profile</h4>
        </span>
      </div>
    </div>
    <div class="marT24 modal-body" *ngIf="companyHiringType == '1'">
      <p class="marB8 colorProfile">Ex-Infosys Profiles:</p>
      <form>
        <div class="row">
          <div class="col-5">
            <mat-form-field class="custom-form-field">
              <mat-label>Select Profile </mat-label>
              <mat-select [formControl]="exInfyProfileSelect" (selectionChange)="onExinfyOptionSelect($event.value)">
                <mat-option *ngFor="let profiles of exInfyUnitList" [value]="profiles.unitCode">
                  {{ profiles.unitCode }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="exInfyProfileSelect.touched || exInfyProfileSelect.hasError('required')" id="exinfyP">
                Field is required*
              </mat-error>
            </mat-form-field>
            <div style="color: green; font-size: small" *ngIf="assignExinfySuccessMsg" id="exinfysuccess">
              {{ assignExinfySuccessMsg }}
            </div>
            <div class="errMsg" *ngIf="assignExinfyMsg">
              {{ assignExinfyMsg }}
            </div>
          </div>
          <div class="col-5">
            <mat-form-field class="custom-form-field">
              <mat-label>No. of Profiles</mat-label>
              <input matInput [formControl]="exInfyProfilesCount" />
              <mat-error *ngIf="exInfyProfilesCount.touched && exInfyProfilesCount.hasError('required')" id="exinfyPC">
                Field is required*
              </mat-error>
              <mat-error *ngIf="exInfyProfilesCount.touched && exInfyProfilesCount.hasError('pattern')" id="exinfyPCe">
                Please enter only numbers.
              </mat-error>
            </mat-form-field>
            <div class="errMsg" *ngIf="exInfyprofileCountErrMsg" id="exinfyprofilesErrMsg">
              {{ exInfyprofileCountErrMsg }}
            </div>
          </div>
          <div class="col-2 customImg" id="assign-exinfy">
            <span class="whiteIcon-Circle-small marR8 choiseChip"> </span>
            <img
              class="tickImage"
              src="assets/images/icons/default_icons/icon-tick-dark.png"
              alt="assign-icon-exinfy"
              (click)="assignExinfyProfiles()"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-body marT4">
      <p class="marB8 colorProfile">All Profiles:</p>
      <form [formGroup]="unitSourceCountFormgroup">
        <div *ngIf="companyHiringType == '1'">
          <div class="row" formArrayName="unitCountArray" *ngFor="let unitCount of getUnitControls(); let i = index">
            <ng-container [formGroupName]="i">
              <div class="col-5" *ngIf="unitArrayControl.at(i).get('units')">
                <mat-form-field class="custom-form-field">
                  <input
                    type="text"
                    placeholder="PU"
                    matInput
                    formControlName="units"
                    [matAutocomplete]="auto"
                    name="unitInput{{ i }}"
                  />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUnit($event.option.value, i)">
                    <mat-option
                      *ngFor="let unit of filteredUnits[i] | async"
                      [value]="unit"
                      [disabled]="disableUnitSource(unit, 'unit', i)"
                      id="selectedUnit-{{ unit }}"
                    >
                      {{ unit }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-5" *ngIf="unitArrayControl.at(i).get('units')">
                <mat-form-field class="custom-form-field">
                  <input
                    type="text"
                    matInput
                    placeholder="No. of Profiles"
                    formControlName="profileCount"
                    (keyup)="validateUnitCount(i)"
                    name="countInput{{ i }}"
                    autocomplete="off"
                  />
                </mat-form-field>
                <div>
                  <div
                    *ngIf="unitArrayControl.at(i).get('profileCount').hasError('maxError')"
                    class="nopad nomar"
                    style="font-size: small"
                    id="error-msg"
                  >
                    <span class="mat-error DSA_infoTxt"
                      >Please enter value less than {{ unitArrayControl.at(i).get('maxCount').value.count }}</span
                    >
                  </div>
                  <div
                    *ngIf="unitArrayControl.at(i).get('profileCount').hasError('pattern')"
                    class="nopad nomar custom-style"
                  >
                    <span class="mat-error DSA_infoTxt">Please enter only numbers greater than zero.</span>
                  </div>
                </div>
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  !hideDeleteBtn &&
                  !unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('units')
                "
                id="delete-icon{{ i }}"
              >
                <img
                  src="assets/images/icons/default_icons/icon-delete-mini.png"
                  alt="delete-icon"
                  (click)="deleteUnitSourceRow(i, 'unit')"
                />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  hideDeleteBtn &&
                  unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('units')
                "
                id="process-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-process-complete-sm.png" alt="tick-icon" />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  hideDeleteBtn &&
                  !unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('units')
                "
                id="error-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-error-small.png" alt="error-icon" />
              </div>
              <div class="col-5" *ngIf="unitArrayControl.at(i).get('source')">
                <mat-form-field
                  class="custom-form-field"
                  [ngClass]="unitArrayControl.at(i).get('source') ? 'customClassSource' : ''"
                >
                  <input
                    type="text"
                    placeholder="Source"
                    matInput
                    formControlName="source"
                    [matAutocomplete]="auto"
                    name="sourceInput{{ i }}"
                    [readonly]="puUnitSourceInputDisable || sourceReadOnly(i)"
                  />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getSource($event.option.value, i)">
                    <mat-option
                      *ngFor="let source of filteredSource[i] | async"
                      [value]="source"
                      [disabled]="disableUnitSource(source, 'source', i)"
                      id="selectedSource-{{ source }}"
                    >
                      {{ source }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-5" *ngIf="unitArrayControl.at(i).get('source')">
                <mat-form-field
                  class="custom-form-field"
                  [ngClass]="unitArrayControl.at(i).get('source') ? 'customClassSource' : ''"
                >
                  <input
                    type="text"
                    matInput
                    placeholder="No. of Profiles"
                    formControlName="profileCount"
                    (keyup)="validateSourceCount(i)"
                    name="countInput{{ i }}"
                    autocomplete="off"
                    [readonly]="puUnitSourceInputDisable || sourceReadOnly(i)"
                  />
                </mat-form-field>
                <div>
                  <div
                    *ngIf="unitArrayControl.at(i).get('profileCount').hasError('maxError')"
                    class="nopad nomar"
                    style="font-size: small"
                    id="error-msg"
                  >
                    <span class="mat-error DSA_infoTxt"
                      >Please enter value less than {{ unitArrayControl.at(i).get('maxCount').value.count }}</span
                    >
                  </div>
                  <div
                    *ngIf="unitArrayControl.at(i).get('profileCount').hasError('pattern')"
                    class="nopad nomar custom-style"
                  >
                    <span class="mat-error DSA_infoTxt">Please enter only numbers greater than 0.</span>
                  </div>
                </div>
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  !hideDeleteBtn &&
                  !unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('source')
                "
                id="delete-icon{{ i }}"
              >
                <img
                  src="assets/images/icons/default_icons/icon-delete-mini.png"
                  alt="delete-icon"
                  (click)="deleteUnitSourceRow(i, 'source')"
                />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  hideDeleteBtn &&
                  unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('source')
                "
                id="process-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-process-complete-sm.png" alt="tick-icon" />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="
                  hideDeleteBtn &&
                  !unitArrayControl.at(i).get('hideShowBtn').value &&
                  unitArrayControl.at(i).get('source')
                "
                id="error-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-error-small.png" alt="error-icon" />
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="companyHiringType == '4' || companyHiringType == '9'">
          <div
            class="row"
            formArrayName="sourceCountArray"
            *ngFor="let sourceCount of getSourceControls(); let i = index"
          >
            <ng-container [formGroupName]="i">
              <div class="col-5">
                <mat-form-field class="custom-form-field">
                  <input
                    type="text"
                    placeholder="Source"
                    matInput
                    formControlName="source"
                    [matAutocomplete]="auto"
                    name="sourceInput{{ i }}"
                  />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getSource($event.option.value, i)">
                    <mat-option
                      *ngFor="let source of filteredSource[i] | async"
                      [value]="source"
                      [disabled]="disableUnitSource(source, '', i)"
                      id="selectedSource-{{ source }}"
                    >
                      {{ source }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field class="custom-form-field">
                  <input
                    type="text"
                    matInput
                    placeholder="No. of Profiles"
                    formControlName="profileCount"
                    (keyup)="validateSourceCount(i)"
                    name="countInput{{ i }}"
                  />
                </mat-form-field>
                <div>
                  <div
                    *ngIf="sourceArrayControl.at(i).get('profileCount').hasError('maxError')"
                    class="nopad nomar"
                    style="font-size: small"
                    id="error-msg"
                  >
                    <span class="mat-error DSA_infoTxt"
                      >Please enter value less than {{ sourceArrayControl.at(i).get('maxCount').value.count }}</span
                    >
                  </div>
                  <div
                    *ngIf="sourceArrayControl.at(i).get('profileCount').hasError('pattern')"
                    class="nopad nomar custom-style"
                  >
                    <span class="mat-error DSA_infoTxt">Please enter only numbers.</span>
                  </div>
                </div>
              </div>
              <div
                class="col-2 customImg"
                *ngIf="!hideDeleteBtn && !sourceArrayControl.at(i).get('hideShowBtn').value"
                id="delete-icon{{ i }}"
              >
                <img
                  src="assets/images/icons/default_icons/icon-delete-mini.png"
                  alt="delete-icon"
                  (click)="deleteUnitSourceRow(i, 'source')"
                />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="hideDeleteBtn && sourceArrayControl.at(i).get('hideShowBtn').value"
                id="process-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-process-complete-sm.png" alt="tick-icon" />
              </div>
              <div
                class="col-2 customImg"
                *ngIf="hideDeleteBtn && !sourceArrayControl.at(i).get('hideShowBtn').value"
                id="error-icon{{ i }}"
              >
                <img src="assets/images/icons/default_icons/icon-error-small.png" alt="error-icon" />
              </div>
            </ng-container>
          </div>
        </div>
      </form>
      <div *ngIf="companyHiringType == '1'" style="display: inline-block">
        <button
          mat-stroked-button
          class="margin-button"
          (click)="addPU()"
          [ngStyle]="{ outline: '0' }"
          [disabled]="puAddCount == 3"
          name="addPUbutton"
        >
          + Add New PU
        </button>
      </div>
      <div *ngIf="companyHiringType == '1'" style="display: inline-block">
        <button
          mat-stroked-button
          class="margin-button"
          (click)="addSource()"
          [ngStyle]="{ outline: '0' }"
          [disabled]="puSourceDisableOnDelete == 3 || unitArrayControl.length == 0"
          name="addSourcebutton"
        >
          + Add New Source
        </button>
      </div>
      <div *ngIf="companyHiringType == '4' || companyHiringType == '9'">
        <button
          mat-stroked-button
          class="margin-button"
          (click)="addSource()"
          [ngStyle]="{ outline: '0' }"
          [disabled]="sourceArrayControl.length == 3 || disableAssign"
          name="addSourcebutton"
        >
          + Add New Source
        </button>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <div class="row nomarLR padTB16">
          <div class="col-6 padR8" *ngIf="companyHiringType == '1'">
            <button
              mat-flat-button
              name="assignBtn"
              class="primary-btn btnfullWdth"
              style="width: 110px"
              [disabled]="!unitArrayControl.valid || disableAssign || unitArrayControl.length == 0"
              (click)="assignProfiles()"
            >
              Assign
            </button>
          </div>
          <div class="col-6 padR8" *ngIf="companyHiringType == '4' || companyHiringType == '9'">
            <button
              mat-flat-button
              name="assignBtn"
              class="primary-btn btnfullWdth"
              style="width: 110px"
              [disabled]="
                !unitArrayControl.valid ||
                !sourceArrayControl.valid ||
                disableAssign ||
                (sourceArrayControl.length == 0 && unitArrayControl.length == 0)
              "
              (click)="assignProfiles()"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
